import axios from 'axios'

export const api = axios.create({
	baseURL: 'https://app.kaerntencard.at/admin/api',
	responseType: 'json'
})

export const cardApi = axios.create({
	// staging url
	// baseURL: `https://app.kaerntencard.at/admin/api/feratel_test/Cr0jaX7PJmVWiY/KCS01/`,
	baseURL: `https://app.kaerntencard.at/admin/api/feratel/PyANttZQWGfiWi/KCS01/`,
	headers: {
		'Content-type': 'application/x-www-form-urlencoded'
	}
})

export default {}